<div class="root-container mobile">
  <i class="bi bi-list sidebar-toggle mobile-toggle" tabindex="3"></i>
  <img src="assets/images/common/company_logo_v2_light.png" class="logo" alt="logo">
  <div class="current-role">{{ role() }}</div>
  @for (link of links(); track $index) {
    @if (link.children) {
      <div class="link-group"
          routerLinkActive="active"
          [ngClass]="{ 'expanded' : isExpanded(link)  }"
          [routerLinkActiveOptions]="{exact:true}">
        <div class="link-group-header" 
          (click)="toggleGroup(link.name)"> 
            <i [class]="['bi', link.icon]"></i>  
            <span>{{ link.name }}</span>
            <div style="flex-grow: 1;"></div>
            <i 
            class="bi"
            [ngClass]="isExpanded(link) ? 'bi-chevron-down' :  'bi-chevron-up'"></i>  
        </div>
        <div class="link-group-items">
          @for (childLink of link.children; track $index) {
            <a 
                [routerLink]="childLink.url"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{exact:true}">
            <i [class]="['bi', childLink.icon]"></i>{{ childLink.name }}</a>
          }
        </div>
      </div>
    }
    @else {
      <a 
          [routerLink]="link.url"
         routerLinkActive="active"
         [routerLinkActiveOptions]="{exact:true}"
          (click)="removeToggles()"
        >
      <i [class]="['bi', link.icon]"></i>
        {{ link.name }}
      </a>
    }
  }
</div>
